/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import pinkImg from "@images/prepare/pink.png"
import blueImg from "@images/prepare/blue.png"
import yellowImg from "@images/prepare/yellow.png"
import classnames from "gpages/utils/classnames"

import image1 from "@images/bg-hero.png"
import image2 from "@images/hero.png"
import { wxConfig, wxShare } from "@src/utils/wechat"

const prepareImgs = [image1, image2]

const Layout = ({ children, location }) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    let isReady = false
    const prepare = () => {
      let count = 0
      const len = prepareImgs.length
      const counter = () => {
        count++
        if (count === len) {
          isReady = true
        }
      }
      prepareImgs.forEach((src) => {
        const img = new Image()
        img.onload = counter
        img.src = src
      })
    }

    prepare()

    const check = setInterval(() => {
      if (isReady) {
        setReady(true)
        clearInterval(check)
      }
    }, 2100)

    setTimeout(() => {
      setReady(true)
      clearInterval(check)
    }, 10000)
  }, [])

  return (
    <AppContext.Provider value={{}}>
      <Seo />
      <div className={styles.prepare}>
        LOADING...
        <div>
          <img src={pinkImg} alt="" />
          <img src={blueImg} alt="" />
          <img src={yellowImg} alt="" />
        </div>
      </div>
      <div
        className={classnames(styles.main, {
          [styles.ready]: ready,
        })}
      >
        {children}
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
